import React from 'react';

import PropTypes from 'prop-types';
import { Button, Popup, Checkbox, Header } from 'semantic-ui-react';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _startCase from 'lodash/startCase';

import {
  ACTIVE_STATE,
  INACTIVE_STATE,
  ANY_UNIT,
  COLOR_UNIT,
  SIZE_UNIT,
  LabelByFilterValue,
} from '../../constants';
import useStyleRuleConfigurations from '../../hooks/useStyleRuleConfigurations';

import './StyleRulesFilters.scss';

const propTypes = {
  states: PropTypes.arrayOf(PropTypes.oneOf([ACTIVE_STATE, INACTIVE_STATE])).isRequired,
  units: PropTypes.arrayOf(PropTypes.oneOf([ANY_UNIT, COLOR_UNIT, SIZE_UNIT])).isRequired,
  onStatesFilterChange: PropTypes.func.isRequired,
  onUnitsFilterChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

const defaultProps = {};

function StyleRulesFilters({ onStatesFilterChange, onUnitsFilterChange, onReset, states, units }) {
  const { styleRuleConfigurations } = useStyleRuleConfigurations();

  const hasToggledFilters = !_isEmpty(units) || !_isEmpty(states);
  const totalFilters = units.length + states.length;
  const totalFiltersLabel = hasToggledFilters ? `(${totalFilters})` : '';

  const availableUnits = new Set(styleRuleConfigurations.map(({ unit }) => unit));

  return (
    <Popup
      trigger={
        <Button
          content={`Filters ${totalFiltersLabel}`}
          icon="filter"
          className="style-rules-filters-button"
          labelPosition="right"
          basic
          primary
        />
      }
      on="click"
      position="bottom right"
    >
      <div className="style-rules-filters">
        <div className="style-rules-filters-section">
          <Header as="h4">States</Header>
          <Checkbox
            label="Active"
            checked={states.includes(ACTIVE_STATE)}
            onChange={() => onStatesFilterChange(ACTIVE_STATE)}
          />
          <Checkbox
            label="Inactive"
            checked={states.includes(INACTIVE_STATE)}
            onChange={() => onStatesFilterChange(INACTIVE_STATE)}
          />
        </div>
        {availableUnits.size > 1 && (
          <div className="style-rules-filters-section">
            <Header as="h4">Units</Header>
            {Array.from(availableUnits).map((availableUnit) => (
              <Checkbox
                key={availableUnit}
                label={_startCase(_get(LabelByFilterValue, availableUnit, availableUnit))}
                checked={units.includes(availableUnit)}
                onChange={() => onUnitsFilterChange(availableUnit)}
              />
            ))}
          </div>
        )}
        {hasToggledFilters && <Button content="Reset" onClick={onReset} basic compact />}
      </div>
    </Popup>
  );
}

StyleRulesFilters.propTypes = propTypes;
StyleRulesFilters.defaultProps = defaultProps;

export default StyleRulesFilters;
